import axios from '../axios/axios.service';
import qs from 'qs';

export const manufacturerApi = {
  getManufacturerById: async (manufacturerId) => {
    return await axios.get(`/manufacturers/${manufacturerId}`);
  },
  getManufacturers: async (params) => {
    return axios.get(`/manufacturers`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    });
  }
};
